import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {

  constructor() { }

  public export(data, fileName: string) {

    const workBook = XLSX.utils.book_new(); // create a new blank book
    const workSheet = XLSX.utils.json_to_sheet(data);
 //XLSX.utils.book_append_sheet(workBook, workSheet, 'data'); // add the worksheet to the book
 let sheet_name:any=(fileName?fileName:'data')
 sheet_name=(sheet_name?sheet_name:'data').length>30?(sheet_name.substring(0,30)):sheet_name
 XLSX.utils.book_append_sheet(workBook, workSheet, sheet_name); // add the worksheet to the book
 XLSX.writeFile(workBook, fileName + EXCEL_EXTENSION); // initiate a file download in browser
  }

  public customExport()
  {
    // var tableToExcel = (function() {
    //   var uri = 'data:application/vnd.ms-excel;base64,'
    //     , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>'
    //     , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
    //     , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
    //   return function(table, name) {
    //     if (!table.nodeType) table = document.getElementById(table)
    //     var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
    //     window.location.href = uri + base64(format(template, ctx))
    //   }
    // })
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src1613810978/src/src/app/shared/services/excel/excel.service.ts